import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })
  export class BuchungService extends BaseService {
  
    constructor(protected http: HttpClient) { 
      super(http);
    }

    public getAllBuchungen(): Observable<any> {
        let url = '/buchung';
        return this.get(url);
    }

    public getBuchungenByKonto(kontoId: number): Observable<any> {
        let url = '/buchung/konto/' + kontoId;
        return this.get(url);
    }

    public getBuchungen(jahr: number, monat: number): Observable<any> {
        let url = '/buchung/jahr/' + jahr + '/monat/' + monat;
        return this.get(url);
    }

    public getBuchung(buchungId: number): Observable<any> {
        let url = '/buchung/' + buchungId;
        return this.get(url);
    }
}